import React, { useEffect, useState } from 'react'
import { base_url } from '../../../utils/AxiosConfig';
import axios from 'axios';
import { toast } from 'react-toastify';


const DeleteCategoryPop = ({ deleteCatName, handleClose, setModalVisible, isModalVisible }) => {

    const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
        let companyCode = null

        if (storedUserDataArray) {
          companyCode = storedUserDataArray[0].cmpcode
        }

    const [LeaveCatData, setLeaveCatData] = useState();

    const [apiData, setApiData] = useState();


    const closeModal = () => {
        setModalVisible(false);


        // Remove the modal backdrop
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
            backdrop.parentNode.removeChild(backdrop);
        }
    };

    const deleteItem = async () => {
        try {
            const postData = JSON.stringify(apiData)

            const response = await axios.post(
                `${base_url}api/PersonalInfoLeaveCategory`, postData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            );
            if (response?.status === 200) {
                toast.success("Leave Category Created Successfully")
                handleClose()
                closeModal()
            } else {
                console.log("error");
                toast.error("Something went wrong")
                handleClose()
                closeModal()
            }
        } catch (error) {
            console.log("error");
            toast.error("Something went wrong")
            handleClose()
            closeModal()
        }
    }

    useEffect(() => {
        const getLeaveCat = async () => {
            const response = await axios.get(
                `${base_url}api/PersonalInfoLeaveCategoryList/${companyCode}/SINGLE/${deleteCatName}`
            );
            console.log(response.data[0]);
            if (response?.data) {
                setLeaveCatData(response.data[0]);
            } else {
                console.log("error");
            }
        };

        if (deleteCatName) {
            getLeaveCat();
        }

    }, [deleteCatName])


    useEffect(() => {
        if (LeaveCatData) {
            setApiData({
                CmpCode: companyCode,
                mode: 'DELETE',
                name: LeaveCatData?.name || "",
                icon: LeaveCatData?.icon || "-",
                code: LeaveCatData?.code || "",
                type: LeaveCatData?.type || "",
                unit: LeaveCatData?.unit || "",
                validity_From: LeaveCatData?.validity_From || "-",
                validity_To: LeaveCatData?.validity_To || "-",
                effectiveAfter_Input: LeaveCatData?.effectiveAfter_Input || "0",
                effectiveAfter_List: LeaveCatData?.effectiveAfter_List || "",
                reset_List: LeaveCatData?.reset_List || "-",
                carryForward_Input: LeaveCatData?.carryForward_Input || "0",
                carryForward_List: LeaveCatData?.carryForward_List || "-",
                carryForward_Max: LeaveCatData?.carryForward_Max || "0",
                encashment_Input: LeaveCatData?.encashment_Input || "0",
                encashment_List: LeaveCatData?.encashment_List || "",
                encashment_Max: LeaveCatData?.encashment_Max || "0",
                appl_Departments: LeaveCatData?.appl_Departments || "-",
                appl_Designations: LeaveCatData?.appl_Designations || "-",
                appl_Locations: LeaveCatData?.appl_Locations || "-",
                appl_role: LeaveCatData?.appl_role || "",
                appl_Gender: LeaveCatData?.appl_Gender || "-",
                appl_MaritalStatus: LeaveCatData?.appl_MaritalStatus || "-",
                appl_EmployementType: LeaveCatData?.appl_EmployementType || "",
            })
        }
    }, [LeaveCatData])

    // console.log('apiData', apiData)

    console.log('isModalVisible', isModalVisible)

    return (
        <div>
            <div
                className={`modal fade ${isModalVisible ? '' : 'hidden'}`}
                class="modal fade"
                id="deleteModal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1
                                class="modal-title fs-small text-secondary "
                                id="exampleModalLabel"
                            >
                                Delete Leave Category
                            </h1>
                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => handleClose()}
                            ></button>
                        </div>
                        <div class="modal-body">
                            <div className="container-fluid"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}
                            >
                                <div>
                                    Delete {deleteCatName} Category ?
                                </div>
                                <div>
                                    <button className="red-btn"
                                        onClick={() => deleteItem()}

                                    >
                                        {/* <MdOutlineDelete /> */}
                                        &nbsp;Delete
                                    </button>
                                    &nbsp;&nbsp;
                                    <button
                                        className="dash-btn"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        onClick={() => handleClose()}
                                    >
                                        {/* <FaRegEdit /> */}
                                        &nbsp;Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteCategoryPop